var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "materialReceiveList" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "demo-form-inline",
          attrs: { model: _vm.form, size: "small", inline: "" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "物料申请单", prop: "code" } },
            [
              _c("el-input", {
                staticClass: "input__width",
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.form.code,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "code", $$v)
                  },
                  expression: "form.code",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "领用人", prop: "created_by" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    remote: "",
                    "remote-method": _vm.searchReceiver,
                    loading: _vm.personLoading,
                    "no-data-text": "无数据",
                    placeholder: "请选择",
                  },
                  on: {
                    clear: function ($event) {
                      return _vm.searchReceiver("")
                    },
                  },
                  model: {
                    value: _vm.form.created_by,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "created_by", $$v)
                    },
                    expression: "form.created_by",
                  },
                },
                _vm._l(_vm.personOptions.receiver || [], function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: _vm.formatPersonLabel(item),
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "领用人部门", prop: "organize_id" } },
            [
              _c("el-cascader", {
                ref: "organize",
                staticClass: "input__width",
                attrs: {
                  options: _vm.options,
                  "collapse-tags": "",
                  props: {
                    label: "label",
                    value: "value",
                    children: "children",
                    multiple: true,
                    emitPath: false,
                  },
                  clearable: "",
                  placeholder: "请选择",
                },
                model: {
                  value: _vm.form.organize_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "organize_id", $$v)
                  },
                  expression: "form.organize_id",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物料编码", prop: "material_id" } },
            [
              _c("el-input", {
                staticClass: "input__width",
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.form.material_id,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "material_id", $$v)
                  },
                  expression: "form.material_id",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物料名称", prop: "name" } },
            [
              _c("el-input", {
                staticClass: "input__width",
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "物料类型", prop: "material_type" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", multiple: "", clearable: "" },
                  model: {
                    value: _vm.form.material_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "material_type", $$v)
                    },
                    expression: "form.material_type",
                  },
                },
                _vm._l(_vm.materialTypeList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { value: item.value, label: item.label },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "印刷类型", prop: "print_type" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", clearable: "" },
                  model: {
                    value: _vm.form.print_type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "print_type", $$v)
                    },
                    expression: "form.print_type",
                  },
                },
                [
                  _c("el-option", { attrs: { value: "1", label: "标准版" } }),
                  _c("el-option", { attrs: { value: "2", label: "个性化" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "领用状态", prop: "status" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: { placeholder: "请选择", multiple: "", clearable: "" },
                  model: {
                    value: _vm.form.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "status", $$v)
                    },
                    expression: "form.status",
                  },
                },
                [
                  _c("el-option", { attrs: { value: "1", label: "待领取" } }),
                  _c("el-option", { attrs: { value: "2", label: "已领取" } }),
                  _c("el-option", { attrs: { value: "0", label: "已取消" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "操作人", prop: "updated_by" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "input__width",
                  attrs: {
                    clearable: "",
                    filterable: "",
                    remote: "",
                    "remote-method": _vm.searchOperator,
                    loading: _vm.personLoading,
                    "no-data-text": "无数据",
                    placeholder: "请选择",
                  },
                  on: {
                    clear: function ($event) {
                      return _vm.searchOperator("")
                    },
                  },
                  model: {
                    value: _vm.form.updated_by,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "updated_by", $$v)
                    },
                    expression: "form.updated_by",
                  },
                },
                _vm._l(_vm.personOptions.operator || [], function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: _vm.formatPersonLabel(item),
                      value: item.id,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "领取时间", prop: "apply_time" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  "value-format": "yyyy-MM-dd",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                model: {
                  value: _vm.form.apply_time,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "apply_time", $$v)
                  },
                  expression: "form.apply_time",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", icon: "el-icon-search" },
                  on: { click: _vm.search },
                },
                [_vm._v("搜索")]
              ),
              _vm.$hasBtnRoles("/material/order/other-receive-apply")
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "success" },
                      on: { click: _vm.handleAdd },
                    },
                    [_vm._v("领用申请")]
                  )
                : _vm._e(),
              _vm.$hasBtnRoles("/material/order/other-receive-export")
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "warning" },
                      on: { click: _vm.handleExport },
                    },
                    [_vm._v("导出")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-top": "10px" },
          attrs: {
            border: "",
            "header-cell-style": { background: "#F1F1F1", color: "#333333" },
            data: _vm.dataList,
            "row-key": function (row) {
              return row._rowKey
            },
            "span-method": _vm.objectSpanMethod,
            "tooltip-effect": "dark",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "领用申请单",
              prop: "code",
              align: "left",
              width: "120px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("div", [_vm._v(_vm._s(scope.row.code || "-"))]),
                    _c("div", { class: _vm.statusClass(scope.row) }, [
                      _vm._v(" " + _vm._s(scope.row.status_des || "-") + " "),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "创建时间",
              prop: "created_at",
              align: "left",
              width: "150px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "领用人",
              prop: "created_user_name",
              align: "left",
              width: "100px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(scope.row.created_user_name || "-") + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "领用部门",
              prop: "organize_name",
              align: "left",
              width: "110px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(" " + _vm._s(scope.row.organize_name || "-") + " "),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "领取日期",
              prop: "apply_date",
              align: "left",
              width: "130px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "备注",
              "min-width": "200px",
              prop: "remark",
              "show-overflow-tooltip": "",
              align: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.remark || "-") + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作人",
              prop: "updated_user_name",
              align: "left",
              width: "120px",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(scope.row.updated_user_name || "-") + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "物料编码",
              prop: "material_id",
              align: "left",
              width: "110px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "物料预览图",
              width: "120px",
              prop: "pre_img",
              align: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.pre_img
                      ? _c("el-image", {
                          staticStyle: { height: "50px", width: "70px" },
                          attrs: {
                            src: scope.row.pre_img,
                            "preview-src-list": [scope.row.pre_img],
                            fit: "contain",
                          },
                        })
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "物料名称",
              "min-width": "150px",
              prop: "name",
              align: "left",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "物料类型",
              prop: "material_type_des",
              align: "left",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "工艺材质", prop: "craft_type_des", align: "left" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "规格",
              prop: "attribute_str",
              align: "left",
              width: "110px",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "印刷类型", prop: "print_type_des", align: "left" },
          }),
          _c("el-table-column", {
            attrs: {
              label: "领取仓库",
              prop: "branch_office_name",
              width: "110px",
              align: "left",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "申请领用数量",
              prop: "apply_num",
              align: "left",
              width: "120px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "领取数量",
              prop: "receive_num",
              align: "left",
              width: "100px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "已退还数量",
              prop: "refund_num",
              align: "left",
              width: "130px",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "120px",
              align: "left",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    ["0", "2"].includes(scope.row.status)
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleView(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        )
                      : _vm.$hasBtnRoles(
                          "/material/order/other-receive-register"
                        ) &&
                        Number(scope.row.receive_num) === 0 &&
                        !scope.row.card_rev_id
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleReturnReceive(
                                  scope.row,
                                  "receive"
                                )
                              },
                            },
                          },
                          [_vm._v("领取")]
                        )
                      : _vm._e(),
                    _vm.$hasBtnRoles("/material/order/other-receive-refund") &&
                    Number(scope.row.receive_num) > Number(scope.row.refund_num)
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleReturnReceive(
                                  scope.row,
                                  "refund"
                                )
                              },
                            },
                          },
                          [_vm._v("退还")]
                        )
                      : _vm._e(),
                    scope.row.status === "1" && !scope.row.card_rev_id
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleCancel(scope.row)
                              },
                            },
                          },
                          [_vm._v("取消")]
                        )
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "right", margin: "20px 0" } },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
              "page-size": 20,
              "page-sizes": [20, 50, 100, 200],
              total: _vm.pages.totalCount,
              "current-page": _vm.pages.page,
            },
            on: {
              "current-change": _vm.currentChange,
              "size-change": _vm.sizeChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawerApply,
            size: "88%",
            "custom-class": "myDrawer",
            title: "其他物料领取申请",
            "destroy-on-close": "",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerApply = $event
            },
          },
        },
        [
          _c("material-receive-apply-drawer", {
            ref: "receiveApplyDrawer",
            on: {
              close: function ($event) {
                _vm.drawerApply = false
              },
              emitGetList: _vm.handleEmitGetList,
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawerView,
            size: "88%",
            "custom-class": "myDrawer",
            title: "其他物料领取/退还详情",
            "destroy-on-close": "",
            "append-to-body": "",
            "wrapper-closable": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerView = $event
            },
          },
        },
        [
          _c("material-receive-view-drawer", {
            attrs: { id: _vm.currentRowId },
            on: {
              close: function ($event) {
                _vm.drawerView = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawerReceiveRefund,
            size: "88%",
            "custom-class": "myDrawer",
            title: _vm.drawerReceiveRefundTitle,
            "destroy-on-close": "",
            "append-to-body": "",
            "wrapper-closable": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerReceiveRefund = $event
            },
          },
        },
        [
          _c("material-receive-refund-drawer", {
            key: "rr_" + _vm.currentAction + "_" + _vm.currentRowId,
            attrs: { id: _vm.currentRowId, action: _vm.currentAction },
            on: {
              emitGetList: _vm.handleEmitGetList,
              close: function ($event) {
                _vm.drawerReceiveRefund = false
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }